import store from 'store/store';
import axios from 'axios';

export async function getApiRequestHeader(isFormData = false) {
  const { token } = store.getState().common?.user || {};

  return {
    Accept: 'application/json',
    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    Authorization: `Bearer ${token}`,
  };
}
const BASE_URL = process.env.REACT_APP_BASE_URL;
console.log("BASE_URL" ,BASE_URL)

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 200000,
  withCredentials: false,
});

export async function updateHeaders(isFormData = false) {
  const header = await getApiRequestHeader(isFormData);
  instance.defaults.headers = header as any;
}

interface RequestParams {
  method: 'get' | 'post' | 'put' | 'delete' | 'patch';
  url: string;
  data?: any;
  headers?: any;
  isFormData?: boolean;
}

export async function request({ method, url, data, headers, isFormData = false }: RequestParams) {
  if (headers === undefined) {
    await updateHeaders(isFormData);
  }
  const promise = instance[method](url, data);
  let response;
  try {
    response = await promise;
  } catch (error) {
    throw error.response;
  }

  return response;
}

export async function get(url: string, params = {}) {
  const query = new URLSearchParams(params).toString();
  if (query) {
    url += (url.includes('?') ? '&' : '?') + query;
  }

  return request({ method: 'get', url });
}

export async function del(url: string, data = {}) {
  return request({ method: 'delete', url, data: { data } });
}

export async function post(url: string, data = {}, isFormData = false) {
  return request({ method: 'post', url, data, isFormData });
}

export async function put(url: string, data = {}, isFormData = false) {
  return request({ method: 'put', url, data, isFormData });
}

export async function patch(url: string, data = {}, isFormData = false) {
  return request({ method: 'patch', url, data, isFormData });
}
